import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_semibold } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: block;
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(3)};
  background-color: ${base_colorRaisedSurface};
  padding: ${spacing(5)} ${spacing(6)};

  /* Rubik faces are registered at font-weight: normal, so the browser's default
     <h3> { font-weight: bold } would layer a synthetic bold on top of
     Rubik-Semibold — pin it to normal and let the family carry the weight. */
  .SettingsTile-kicker {
    margin: 0 0 ${spacing(4)};
    font-family: ${font_family_weight_semibold};
    font-weight: normal;
    font-size: 11.5px;
    line-height: 16px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${text_colorTextSecondary};
  }
`
